import { createSlice } from "@reduxjs/toolkit";

// Define a type for the slice state
interface IInventoryProject {
  data: Array<IProject> | null;
  pageSize: number;
  pageNumber: number;
  totalCount: number;
  showLoading: ILoading;
  isLoading: boolean;
  isSuccess: boolean;
  projectDetails: IProject | null;
}

// Define the initial state using that type
const initialState: IInventoryProject = {
  data: null,
  pageSize: 0,
  pageNumber: 0,
  totalCount: 0,
  showLoading: {
    sourceAction: "",
    state: false,
  },
  isLoading: false,
  isSuccess: false,
  projectDetails: null,
};

export const inventoryProjectSlice = createSlice({
  name: "inventoryProject",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.showLoading = {
        sourceAction: action.payload.sourceAction,
        state: true,
      };
      state.isLoading = action.payload.isLoading
        ? action.payload.isLoading
        : false;
      state.isSuccess = action.payload.isSuccess
        ? action.payload.isSuccess
        : false;
    },
    resetLoading: (state, action) => {
      state.showLoading = {
        sourceAction: "",
        state: false,
      };
      state.isLoading = action.payload.isLoading
        ? action.payload.isLoading
        : false;
      state.isSuccess = action.payload.isSuccess
        ? action.payload.isSuccess
        : false;
    },
    replaceInventoryProject: (state, action) => {
      state.data = action.payload.data;
      state.pageSize = action.payload.pageSize;
      state.pageNumber = action.payload.pageNumber;
      state.totalCount = action.payload.totalCount;
    },
    addInventoryProject: (state, action) => {
      const newItem = action.payload.data;
      if (state.data && state.data.length > state.pageSize) {
        state.data.pop();
      }
      state.data = state.data ? [newItem, ...state.data] : [newItem];
      state.totalCount = state.totalCount + 1;
    },
    updateInventoryProject: (state, action) => {
      const { data } = action.payload;
      if (state.data) {
        const index = state.data.findIndex(item => item.id === data.id);
        if (index !== -1) {
          state.data[index] = data;
        }
      }
      state.projectDetails = data;
    },
    deleteInventoryProject: (state, action) => {
      const inventoryProjectToRemove: IProject = action.payload.data;
      const newInventoryProjectData =
        state.data &&
        state.data.filter((inventoryProject: IProject) => {
          return inventoryProject.id !== inventoryProjectToRemove.id;
        });
      state.data = newInventoryProjectData;
      state.totalCount = state.totalCount - 1;
    },
    setInventoryProjectDetails: (state, action) => {
      state.projectDetails = action.payload.data;
    },
  },
});

export const inventoryProjectActions = inventoryProjectSlice.actions;

export default inventoryProjectSlice.reducer;
